import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import * as roleService from '../../services/role/roleService';
import StandardDrawer from '../../components/common/StandardDrawer';

const RoleCreateForm = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState('');
  
  useEffect(() => {
    if (visible) {
      form.resetFields();
      setDescriptionValue('');
    }
  }, [visible, form]);

  const handleDescriptionChange = (e) => {
    setDescriptionValue(e.target.value);
  };

  const clearDescription = () => {
    form.setFieldsValue({ description: '' });
    setDescriptionValue('');
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      //构造API请求数据
      const roleData = {
        name: values.name,
        code: values.code,
        description: values.description || ''
      };
      
      const response = await roleService.createRole(roleData);
      
      if (response.success) {
        message.success(t('role.createSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('role.createFailed'));
      }
    } catch (error) {
      console.error('Create role failed:', error);
      message.error(error.message || t('role.createFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StandardDrawer
      visible={visible}
      onClose={onCancel}
      onOk={handleSubmit}
      title={t('role.createTitle')}
      confirmLoading={loading}
      width={480}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: '24px 0' }}
      >
        <Form.Item
          name="name"
          label={<span className="required-label">{t('role.name')}</span>}
          rules={[
            { required: true, message: t('role.nameRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('role.nameSpecialCharNotAllowed') || '名称不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input 
            placeholder={t('role.namePlaceholder')} 
            maxLength={50} 
            suffix={
              <span
                onClick={() => form.setFieldsValue({ name: '' })}
                style={{ color: 'rgba(0,0,0,.45)', cursor: 'pointer' }}
              >
                ×
              </span>
            }
          />
        </Form.Item>

        <Form.Item
          name="code"
          label={<span className="required-label">{t('role.code')}</span>}
          rules={[
            { required: true, message: t('role.codeRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('role.codeSpecialCharNotAllowed') || '代码不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input 
            placeholder={t('role.codePlaceholder')} 
            maxLength={50} 
            suffix={
              <span
                onClick={() => form.setFieldsValue({ code: '' })}
                style={{ color: 'rgba(0,0,0,.45)', cursor: 'pointer' }}
              >
                ×
              </span>
            }
          />
        </Form.Item>

        <Form.Item
          name="description"
          label={t('role.description')}
        >
          <div style={{ position: 'relative' }}>
            <Input.TextArea 
              placeholder={t('role.descriptionPlaceholder')} 
              maxLength={100} 
              rows={4}
              onChange={handleDescriptionChange}
            />
            {descriptionValue && (
              <span
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '12px',
                  color: 'rgba(0,0,0,.45)',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
                onClick={clearDescription}
              >
                ×
              </span>
            )}
          </div>
        </Form.Item>
      </Form>
    </StandardDrawer>
  );
};

export default RoleCreateForm;